// Individual search result

import React from "react";
import PropTypes from "prop-types";

import string from "helpers/string";

const propTypes = {
  hit: PropTypes.shape({
    author: PropTypes.string,
    blurb: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    primaryTitle: PropTypes.string.isRequired,
    secondaryTitle: PropTypes.string
  }).isRequired,
  isAPlus: PropTypes.bool
};

const defaultProps = {
  isAPlus: false
};

const Hit = ({ hit, isAPlus }) => {
  const title = hit.secondaryTitle
    ? `${hit.secondaryTitle} > ${hit.primaryTitle}`
    : hit.primaryTitle;
  const category = hit.category.split(" > ")[1];

  let hitClass = "hit-item";
  let categoryClass = `category ${category
    .toLowerCase()
    .replace("&", "")
    .replace(/[ ]+/g, "-")}`;
  let titleClass = "title";
  let blurbClass = "";
  let authorClass = "search__hit-author";

  let isBlurred = false;
  if (
    !isAPlus &&
    ["Lit Guide", "Poetry Guide", "Shakescleare", "Lit Term"].indexOf(
      category
    ) < 0
  ) {
    hitClass += " blurred";
    categoryClass += " blurred";
    titleClass += " blurred-text";
    blurbClass += " blurred-text";
    authorClass += " blurred-text";

    isBlurred = true;
  }

  return (
    <div className={hitClass}>
      {isBlurred ? (
        <div>
          <span className={categoryClass}>{category}</span>
          <span className={titleClass}>{title}</span>
        </div>
      ) : (
        <div>
          <a className={categoryClass} href={hit.path}>
            {category}
          </a>
          <a className={titleClass} href={hit.path}>
            {title}
          </a>
        </div>
      )}
      {category !== "Lit Term" && (
        <div className={authorClass}>by {hit.author}</div>
      )}
      <div className={blurbClass}>{string.htmlDecode(hit.blurb)}</div>
    </div>
  );
};

Hit.propTypes = propTypes;
Hit.defaultProps = defaultProps;

export default Hit;
